import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import avathor from "../../assets/avatar.jpg"
import { adminLogout } from "../../slice/adminUser/adminUserSlice";

const TopHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toggleBtnRef = useRef(null);

  const handleLogout = () => {
    // ✅ Use adminLogout
    dispatch(adminLogout());
    navigate("/admin/login");
  };

  /* ================= TOGGLE SIDEBAR ================= */
  const toggleSidebar = () => {
    const sidebar = document.querySelector(".main-nav");
    if (!sidebar) return;

    sidebar.classList.toggle("spassov");
  };

  /* ================= CLICK OUTSIDE TO CLOSE ================= */
  useEffect(() => {
    const handleClickOutside = (e) => {
      const sidebar = document.querySelector(".main-nav");
      if (!sidebar) return;

      const isSidebarOpen = sidebar.classList.contains("spassov");

      if (
        isSidebarOpen &&
        !sidebar.contains(e.target) &&
        !toggleBtnRef.current?.contains(e.target)
      ) {
        sidebar.classList.remove("spassov");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="topbar">
      <div className="container-fluid">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <div className="topbar-item">
              <button
                ref={toggleBtnRef}
                type="button"
                className="button-toggle-menu me-2"
                onClick={toggleSidebar}
              >
                <iconify-icon
                  icon="solar:hamburger-menu-broken"
                  className="fs-24 align-middle"
                />
              </button>
            </div>

            <div className="topbar-item">
              <h4 className="fw-bold mb-0 white">Welcome!</h4>
            </div>
          </div>

          <div className="d-flex align-items-center gap-1">
            <div className="dropdown topbar-item">
              <button className="topbar-button" data-bs-toggle="dropdown">
                <img
                  className="rounded-circle"
                  width={32}
                  src={avathor}
                  alt="avatar"
                />
              </button>

              <div className="dropdown-menu dropdown-menu-end">
                <button
                  className="dropdown-item text-danger"
                  onClick={handleLogout}
                >
                  <i className="bx bx-log-out me-1" />
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopHeader;